import { render, staticRenderFns } from "./YA_HomeContent3.vue?vue&type=template&id=54b7651d&scoped=true"
import script from "./YA_HomeContent3.vue?vue&type=script&lang=js"
export * from "./YA_HomeContent3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b7651d",
  null
  
)

export default component.exports